(() => {
  const instances = new WeakMap();
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const init = (viewport) => {
    if (!viewport || instances.has(viewport) || !mobileQuery.matches || !window.Swiper) return;

    const rail = viewport.querySelector('[data-testimonial-rail]');
    if (!rail) return;
    viewport.classList.add('swiper');
    rail.classList.add('swiper-wrapper');
    rail.querySelectorAll(':scope > *').forEach((slide) => slide.classList.add('swiper-slide'));

    const swiper = new window.Swiper(viewport, {
      slidesPerView: 1.2,
      spaceBetween: 14,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      speed: 560,
      grabCursor: true,
      resistanceRatio: 0.82,
      watchOverflow: true,
      keyboard: { enabled: true, onlyInViewport: true },
    });
    instances.set(viewport, swiper);
  };

  const destroy = (viewport) => {
    const swiper = instances.get(viewport);
    if (!swiper) return;
    swiper.destroy(true, true);
    instances.delete(viewport);
    viewport.classList.remove('swiper', 'swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
    const rail = viewport.querySelector('[data-testimonial-rail]');
    rail?.classList.remove('swiper-wrapper');
    rail?.removeAttribute('style');
    rail?.querySelectorAll(':scope > *').forEach((slide) => {
      slide.classList.remove('swiper-slide', 'swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
      slide.removeAttribute('style');
    });
  };

  const sync = (root = document) => {
    root.querySelectorAll('[data-testimonial-swiper]').forEach((viewport) => {
      if (mobileQuery.matches) init(viewport);
      else destroy(viewport);
    });
  };

  document.addEventListener('DOMContentLoaded', () => sync());
  window.addEventListener('load', () => sync(), { once: true });
  mobileQuery.addEventListener('change', () => sync());
  document.addEventListener('shopify:section:load', (event) => sync(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-testimonial-swiper]').forEach(destroy);
  });
})();
